// extracted by mini-css-extract-plugin
export var table = "_ys-0";